<template>
  <div class="en">
    {{ en }}
  </div>
  <div class="jp" v-if="jp">
    {{ jp }}
  </div>
</template>

<script>
export default {
  props: {
    en: {
      type: String,
      default: "",
      required: true,
    },
    jp: {
      type: String,
      default: "",
      required: true,
    },
  },
};
</script>

<style scoped>
@media (min-width: 0px) {
  .en {
    display: flex;
    align-items: center;
    margin-top: 1.25rem;
    padding-left: 1.5625rem;
    font-size: 2.1875rem;
    font-weight: 500;
  }

  .jp {
    display: flex;
    margin-top: 0.4375rem;
    padding-left: 1.5625rem;
    font-size: 0.6875rem;
    font-weight: 300;
    color: #909090;
  }
}

@media (max-width: 640px) {
  .en {
    letter-spacing: 0.028125rem;
  }
}

@media (min-width: 640px) {
  .en {
    justify-content: center;
    padding-top: 4.375rem;
    padding-left: 0;
    font-size: 2.25rem;
    font-weight: 600;
    text-align: center;
  }
  .jp {
    justify-content: center;
    padding-left: 0;
    font-size: 0.875rem;
    text-align: center;
    color: #202020;
  }
}
</style>
